import store from 'app/store'

import { AsyncAjaxPost } from 'components/Common/AsyncAjaxService'
import FileUpload from 'components/Controls/FileUpload'
import VGPopUp from 'components/Controls/VGPopUp'
import React, { Fragment, useEffect, useRef, useState } from 'react'
import { Form } from 'react-bootstrap'
import ReactDom, { createPortal, unmountComponentAtNode } from 'react-dom'
import { utils, LoginUserType, ResponseCode } from "../../utils/Utils";
import Toast from 'components/WebDesigner/Toast'
import $ from "jquery";
import Loader from "../Common/Loader";
import Dropdown from 'react-bootstrap/Dropdown';
import useGenerateToken from 'components/Hook/useGenerateToken'

const AddEditlayoutPopup = (props) => {

    const layoutName = useRef(null);
    const isDuplicate = props.isDuplicate;
    const isBuilderPage = props.isBuilderPage;

    const { ReactBusinessId, ReactUserID, UserType } = store.getState().Business;
    const LayoutDetail = props.layoutDetails;
    const LayoutID = props.LayoutID
    const cardImgPath = window.location.href.indexOf("vagaro.com") > 0 ? ("https://d396040dc4cf62cf5770-d11e112dbdab6afc64c448f17b56c3c3.ssl.cf2.rackcdn.com/WB/"):("https://f745786de3dd98dac855-36e09dc6f87385bab9d0e7ff5c0d38c7.ssl.cf2.rackcdn.com/WB/");
    const CountMatches = (stateValue) => {
        var val = "";
        var num = 0;
        const regexfornumber = /^(.*?Copy)(\s\d+)?$/;
        const matchesnumber = stateValue.match(regexfornumber);
        const containsCopy = /\bCopy\b/.test(stateValue);

        if (matchesnumber && matchesnumber[2]) {
            val = stateValue.replace(/Copy\s\d+$/, '').trim();
            num = 1;
        }
        else if (containsCopy) {
            val = stateValue.replace(" Copy", "");
        }
        else {
            val = stateValue.trim();
            //num = 1; //first time not required
        }
        // var SameStyleName = props.allStyleName.filter(
        //     (col) => col.styleName.replace(regex, '').trim() === val
        // );
        var SameStyleName = props.allLayoutName.filter((col) => col.layoutName.toLowerCase().includes(`${val.toLowerCase()}`) === true)
        const newNumber = SameStyleName.length;
        if (newNumber == 1) {
            return `${val} ${"Copy"}`;
        }
        else {
            return `${val} ${"Copy"} ${newNumber}`;
        }
    };

    const [isValidLayoutTitle, setisValidLayoutTitle] = useState(true);
    const [isValidLayoutDescription, setisValidLayoutDescription] = useState(true);
    const [isValidLayoutImage, setisValidLayoutImage] = useState(true);

    const [layoutTitle, setLayoutTitle] = useState((isDuplicate === true && isBuilderPage == false) ? (typeof LayoutDetail != undefined && LayoutDetail != null ? CountMatches(LayoutDetail.layoutTitle) : "") : typeof LayoutDetail != undefined && LayoutDetail != null ? LayoutDetail.layoutTitle : "");
    const [layoutDescription, setLayoutDescription] = useState(typeof LayoutDetail != 'undefined' && LayoutDetail != null ? LayoutDetail.layoutDescription : "");
    const [layoutImage, setLayoutImage] = useState(typeof LayoutDetail != 'undefined' && LayoutDetail != null ? LayoutDetail.layoutImage : "");

    const [layoutUpdate, setLayoutUpdate] = useState([]);
    const [isValidLayoutSameTitle, setisValidLayoutSameTitle] = useState(true);
    const [isLoading, setLoading] = useState(false);

    const SaveLayoutUploadImage = (filename, Base64, height, width, filesDetails, divMain) => {
        LayoutUpload(filename, Base64, height, width, filesDetails, false);
    };

    const VagaroAPIEnum = {
        LayoutUploadImage: "layout/uploadlayoutimage",
        DeleteUploadLayoutImage: "layout/deleteuploadfile",
        SaveLayout: "layout/saveupdate",
        DuplicateLayout: "layout/duplicate"
    };

    const LayoutImageSize = {
        width: 1032,
        height: 1280
    }

    const readFile = (file, onLoadCallback) => {
        var reader = new FileReader();
        reader.onload = onLoadCallback;
        reader.readAsDataURL(file);
    };
    const imageSize = (filename, callback) => {

        var img = new Image();
        img.onload = function () {
            var myResult = {
                width: img.width,
                height: img.height,
            };
            callback(myResult);
        };
        img.src = filename;
        img.onerror = function () {
            var myResult = {
                width: -101,
                height: -101,
            };
            callback(myResult);
        };
    };

    useEffect(() => {
        layoutName.current.focus();
    }, [])
    const LayoutUploadImageReq = (
        filename,
        Base64
    ) => {
        const Requestdata = {};
        Requestdata.FileName = filename;
        Requestdata.base64image = "url(\"data:image/png;base64," + Base64 + "\")";
        Requestdata.Foldername = "WB";
        return Requestdata;
    };

    const LayoutUpload = async (
        filename,
        Base64,
        width,
        height,
        filesDetails,
        divMain
    ) => {
        const access_token = await useGenerateToken(props.dispatch);

        var isvalid = false;
        console.log("data:image/png;base64,"+Base64);
            imageSize("data:image/png;base64,"+Base64, function (sizeAttributes) {
                if (sizeAttributes.height === -101 && sizeAttributes.width === -101) {
                    const TitleEnum = "Alert!";
                    const BodyEnum =
                        "The image you have uploaded seems to be corrupted. Please upload another image.";
                    utils.ShowAlert(TitleEnum, BodyEnum, "OpenDialog2");
                } else if (
                    (height === LayoutImageSize.height && width === LayoutImageSize.width && height <= LayoutImageSize.height && width <= LayoutImageSize.width) ||
                    (height === LayoutImageSize.height && width === LayoutImageSize.width)
                ) {
                    isvalid = true;
                } else {
                    const TitleEnum = "Incorrect Image Size";
                    const BodyEnum = `The width and height required for the image is ${LayoutImageSize.width}x${LayoutImageSize.height}`;
                    utils.ShowAlert(TitleEnum, BodyEnum, "OpenDialog2");
                }
                if (isvalid) {
                    if (utils.Validate(access_token)) {
                        props.setLoading(true);
                        const Requestdata = LayoutUploadImageReq(
                            filename,
                            Base64
                        );
                        AsyncAjaxPost(
                            VagaroAPIEnum.LayoutUploadImage,
                            Requestdata,
                            access_token,
                            function onSuccess(data) {
                                try {
                                    if (data != null && data.data != null && data.data.data != null) {
                                        setLayoutImage(data.data.data);
                                        setisValidLayoutImage(true);
                                        $('.drop-file-upload-lg').prop('title', "");
                                    }
                                    props.setLoading(false);
                                } catch (error) {
                                    props.setLoading(false);
                                }
                            },
                            function OnError() {
                                props.setLoading(false);
                            }
                        );
                    }
                    else {
                        utils.ShowAlert("Message", "Please reload this page and try again.", "OpenDialog");
                    }
                }
            });

    };
    const PopupClose = () => {
        unmountComponentAtNode(document.getElementById("OpenDialog"));
    };

    const PopupCloseConfirmation = () => {
        unmountComponentAtNode(document.getElementById("OpenDialog1"));
    };

    const DeleteLayoutImage = async (
        filename
    ) => {
        const access_token = await useGenerateToken(props.dispatch);
        if (utils.Validate(access_token)) {
            PopupCloseConfirmation();
            props.setLoading(true);
            const Requestdata = {};
            Requestdata.FileName = filename;
            Requestdata.Foldername = "WB";
            await AsyncAjaxPost(
                VagaroAPIEnum.DeleteUploadLayoutImage,
                Requestdata,
                access_token,
                function onSuccess(data) {
                    try {
                        if (data !== null && data.data !== null && data.data.data !== null) {
                            setLayoutImage("");
                            setisValidLayoutImage(false);
                        }
                        props.setLoading(false);
                    } catch (error) {
                        props.setLoading(false);
                    }
                },
                function OnError() {
                    props.setLoading(false);
                }
            );
        }
        else {
            utils.ShowAlert("Message", "Please reload this page and try again.", "OpenDialog");
        }
    };
    const EditStyleImageConfirmation = () => {
        $("#generalupload").click();
    }
    const DeleteLayoutImageConfirmation = (filename, Base64) => {
        return ReactDom.render(
            <VGPopUp
                id={"DeleteLayoutImage"}
                show={true}
                onHide={PopupCloseConfirmation}
                title={"Delete Layout Image"}
                dialogClassName="cancelauto-renew-alert"
                body={
                    <div className="alertContent">
                        <p>Your layout image will be removed from the database. Are you sure you want to remove image?</p>
                    </div>
                }
                footer={
                    <Fragment>
                        <button className="w-button w-button-secondary" onClick={() => PopupCloseConfirmation()}>Cancel</button>
                        <button className="w-button w-button-destructive-outline" onClick={() => DeleteLayoutImage(filename, Base64)}>Delete</button>
                    </Fragment >
                }
                isRemoveTabModalIndex={false}
                isShowFooter={true}
                size={"modal-sm"}
                backdrop={true}
            />,
            document.getElementById("OpenDialog1"));
    }

    const SaveLayout = async () => {
        const access_token = await useGenerateToken(props.dispatch);
        if (props.UserType !== LoginUserType.VagaroAdmin) {
            utils.ShowAlert("Alert", "You do not have permission to duplicate style.", "OpenDialog");
        }
        else {
            if (utils.Validate(access_token)) {
                if ((typeof layoutTitle === 'undefined' || layoutTitle === "" || layoutTitle === null)
                    || (typeof layoutDescription === 'undefined' || layoutDescription === "" || layoutDescription === null)
                    || (typeof layoutImage === 'undefined' || layoutImage === "" || layoutImage === null)) {

                    if ((typeof layoutTitle === 'undefined' || layoutTitle === "" || layoutTitle === null)) {
                        setisValidLayoutTitle(false);
                    }
                    else {
                        setisValidLayoutTitle(true);
                    }
                    if ((typeof layoutDescription === 'undefined' || layoutDescription === "" || layoutDescription === null)) {
                        setisValidLayoutDescription(false);
                    } else {
                        setisValidLayoutDescription(true);
                    }

                    if ((typeof layoutImage === 'undefined' || layoutImage === "" || layoutImage === null)) {
                        setisValidLayoutImage(false);
                    } else {
                        setisValidLayoutImage(true);
                    }
                    return;
                }
                var SameLayoutName;
                if (typeof LayoutID != 'undefined' && LayoutID != "" && LayoutID != null) {
                    SameLayoutName = props.allLayoutName.filter(
                        (col) => col.layoutName.toLowerCase() === layoutTitle.toLowerCase() && col.layoutId !== LayoutID
                    );
                }
                else {
                    SameLayoutName = props.allLayoutName.filter(
                        (col) => col.layoutName.toLowerCase() === layoutTitle.toLowerCase()
                    );
                }
                if (SameLayoutName !== 'undefined' && SameLayoutName !== "" && SameLayoutName !== null && SameLayoutName.length > 0) {
                    setisValidLayoutSameTitle(false);
                } else {
                    props.setLoading(true);
                    const Requestdata = {};
                    Requestdata.ID = LayoutID;
                    Requestdata.LayoutTitle = layoutTitle;
                    Requestdata.LayoutDescription = layoutDescription;
                    Requestdata.LayoutImage = layoutImage;
                    Requestdata.ModifyBy = ReactUserID;
                    await AsyncAjaxPost(
                        VagaroAPIEnum.SaveLayout,
                        Requestdata,
                        access_token,
                        function onSuccess(data) {

                            if (
                                data != null &&
                                data.data != null &&
                                data.data.responseCode == ResponseCode.Success
                            ) {
                                if (data != null && data.data != null && data.data.data != null && data.data.data.status === true) {
                                    PopupClose();
                                    if (!isBuilderPage) {
                                        setLayoutUpdate(data.data.data);
                                        props.getLayoutList(props.StyleID, false, true, 1, (props.currentPage * props.pageSize));
                                        props.IsMessageOpen(true);
                                        props.Message("Layout has been updated successfully.");
                                        props.allLayoutNameOperation(isDuplicate ? "Edit" : "Add", LayoutID, layoutTitle);


                                    }
                                    if (props.onSave) {
                                        props.onSave();
                                    }

                                    props.setLoading(false);
                                }
                                else {
                                    PopupClose();
                                    props.setLoading(false);
                                }
                            }
                            else {
                                PopupClose();
                                props.setLoading(false);
                            }
                        },
                        function OnError() {
                            PopupClose();
                            props.setLoading(false);
                        }
                    );
                }
            }
        }
    }

    const DuplicateLayout = async (IsPublish) => {
        const access_token = await useGenerateToken(props.dispatch);
        if (UserType !== LoginUserType.VagaroAdmin) {
            utils.ShowAlert("Alert", "You do not have permission to duplicate style.", "OpenDialog");
        }
        else {
            if (utils.Validate(access_token)) {
                if ((typeof layoutTitle === 'undefined' || layoutTitle === "" || layoutTitle === null)
                    || (typeof layoutDescription === 'undefined' || layoutDescription === "" || layoutDescription === null)
                    || (typeof layoutImage === 'undefined' || layoutImage === "" || layoutImage === null)) {

                    if ((typeof layoutTitle === 'undefined' || layoutTitle === "" || layoutTitle === null)) {
                        setisValidLayoutTitle(false);
                    }
                    else {
                        setisValidLayoutTitle(true);
                    }
                    if ((typeof layoutDescription === 'undefined' || layoutDescription === "" || layoutDescription === null)) {
                        setisValidLayoutDescription(false);
                    } else {
                        setisValidLayoutDescription(true);
                    }

                    if ((typeof layoutImage === 'undefined' || layoutImage === "" || layoutImage === null)) {
                        setisValidLayoutImage(false);
                    } else {
                        setisValidLayoutImage(true);
                    }
                    return;
                }
                var SameLayoutName = props.allLayoutName.filter(
                    (col) => col.layoutName.toLowerCase() === layoutTitle.toLowerCase()
                );
                if (SameLayoutName !== 'undefined' && SameLayoutName !== "" && SameLayoutName !== null && SameLayoutName.length > 0) {
                    setisValidLayoutTitle(false);
                } else {
                    props.setLoading(true);
                    const Requestdata = {};
                    Requestdata.ID = LayoutID;
                    Requestdata.ReactBusinessId = ReactBusinessId;
                    Requestdata.LayoutTitle = layoutTitle;
                    Requestdata.LayoutDescription = layoutDescription;
                    Requestdata.LayoutImage = layoutImage;
                    Requestdata.ModifyBy = ReactUserID;
                    Requestdata.IsPublish = IsPublish;
                    await AsyncAjaxPost(
                        VagaroAPIEnum.DuplicateLayout,
                        Requestdata,
                        access_token,
                        function onSuccess(data) {
                            if (
                                data != null &&
                                data.data != null &&
                                data.data.responseCode == ResponseCode.Success
                            ) {
                                if (data != null && data.data != null && data.data.data != null && data.data.data.layoutId !== undefined && data.data.data.layoutId !== null) {
                                    PopupClose();
                                    props.setLoading(false);
                                    if (!isBuilderPage) {
                                        props.IsMessageOpen(true);
                                        props.Message("Duplicate layout has been created successfully.");
                                        props.getLayoutList(props.StyleID, false, true, 1, (props.currentPage * props.pageSize));
                                        props.allLayoutNameOperation("Add", data.data.data.layoutId, layoutTitle);
                                    }
                                    else {
                                        Toast("Layout has been created successfully.");
                                        setTimeout(() => {
                                            window.location.href = "/"
                                        }, 500);
                                    }
                                }
                                else {
                                    PopupClose();
                                    props.setLoading(false);
                                }
                            }
                            else {
                                PopupClose();
                                props.setLoading(false);
                            }
                        },
                        function OnError() {
                            props.setLoading(false);
                        }
                    );
                }
            }
            else {
                utils.ShowAlert("Message", "Please reload this page and try again.", "OpenDialog");
            }
        }
    }
    const layoutNameValidation = (Title) => {
        setLayoutTitle(Title);
        if (Title === "") {
            setisValidLayoutTitle(false);
            setisValidLayoutSameTitle(true);
        }
        else {
            var SameLayoutName;
            if (isBuilderPage === false && typeof LayoutID != 'undefined' && LayoutID != "" && LayoutID != null) {
                SameLayoutName = props.allLayoutName.filter(
                    (col) => col.layoutName.toLowerCase() === Title.toLowerCase() && col.layoutId !== LayoutID
                );
            }
            else {
                SameLayoutName = props.allLayoutName.filter(
                    (col) => col.layoutName.toLowerCase() === Title.toLowerCase()
                );
            }
            if (SameLayoutName !== 'undefined' && SameLayoutName !== "" && SameLayoutName !== null && SameLayoutName.length !== 0) {
                if (SameLayoutName[0].layoutName.toLowerCase() === Title.toLowerCase()) {
                    setisValidLayoutSameTitle(false);
                    setisValidLayoutTitle(true);
                }
                else {
                    setisValidLayoutSameTitle(true);
                }
            }
            else {
                setisValidLayoutSameTitle(true);
            }
            setisValidLayoutTitle(true);
            const result = Title.replace(/[#%*<>|\/]*/g, "");
            setLayoutTitle(result);
        }
    }

    const layoutDescriptionValidation = (Description) => {
        setLayoutDescription(Description);
        if (Description == "") {
            setisValidLayoutDescription(false);
        }
        else {
            setisValidLayoutDescription(true);
            const result = Description.replace(/[#%*<>|\/]*/g, "");
            setLayoutDescription(result);
        }
    }
    const Editbody = () => {
        return (
            <div className="form-content">
                {isLoading && <Loader />}
                <Form>
                    <Form.Group className={`form-row ${(!isValidLayoutTitle || !isValidLayoutSameTitle) && "form-row-invalid"}`}>
                        <Form.Label>Layout Name: <span style={{ color: "red" }}>*</span></Form.Label>
                        <Form.Control type="text" ref={layoutName} maxLength={50} placeholder="Enter Layout Name" defaultValue={layoutTitle}
                            onChange={(e) => { e.target.value = e.target.value.replace(/[\uD800-\uDFFF].|[\u200D\uFE0F#%*<>|\/]*/g, ""); layoutNameValidation(e.target.value.trim()); }} />
                        {!isValidLayoutSameTitle ? <Form.Control.Feedback type="invalid">Layout name already exist</Form.Control.Feedback> : <Form.Control.Feedback type="invalid">Please enter layout name</Form.Control.Feedback>}
                    </Form.Group>
                    <Form.Group className={`form-row ${!isValidLayoutDescription && "form-row-invalid"}`} >
                        <Form.Label>Layout Description: <span style={{ color: "red" }}>*</span></Form.Label>
                        <Form.Control as="textarea" maxLength={200} rows={3} placeholder="Enter Layout Description" defaultValue={layoutDescription} onChange={(e) => { e.target.value = e.target.value.replace(/[\uD800-\uDFFF].|[\u200D\uFE0F#%*<>|\/]*/g, ""); layoutDescriptionValidation(e.target.value); }} />
                        {!isValidLayoutDescription && <Form.Control.Feedback type="invalid">Please enter layout description</Form.Control.Feedback>}
                    </Form.Group>
                    <Form.Group className={`form-row ${!isValidLayoutImage && "form-row-invalid"}`}>
                        <Form.Label>Layout Image: <span style={{ color: "red" }}>*</span></Form.Label>
                        {layoutImage !== "" &&
                            <div className="drop-file-upload tempalteimg py-t8 uploaded drop-file-upload-lg" style={{ backgroundImage: `url('${cardImgPath + layoutImage}')` }}>
                                <div className="showdelete d-flex flex-column">
                                    <div className="p-2">
                                        <a onClick={() => EditStyleImageConfirmation()}>Edit</a>
                                    </div>
                                    <div className="p-2">
                                        <a onClick={() => DeleteLayoutImageConfirmation(layoutImage)} >Delete</a>
                                    </div>
                                </div>
                            </div>
                        }
                        <div className={`drop-file-upload drop-file-upload-lg ${!isValidLayoutImage && "invalid"}`} style={{ display: layoutImage !== "" ? "none" : "flex" }}>
                            <i className="far fa-cloud-upload" />
                            <span className="upload-note">
                                Drag and drop files here or
                            </span>
                            <span className="upload-trigger">
                                Choose File
                            </span>
                            <FileUpload
                                id="templateupload"
                                height={LayoutImageSize.height}
                                width={LayoutImageSize.width}
                                Message="The width and height required for the image is 1280x1032"
                                ValidFileExtensionMessage="Upload a valid PNG, HEIC, JPEG or JPG image."
                                FileExtension="/(gif|png|jpg|jpeg|GIF|PNG|JPG|JPEG)$/i"
                                savecdn={SaveLayoutUploadImage}
                                setLoading={setLoading}
                            ></FileUpload>
                        </div>
                        <div className="form-text">
                            Upload a {LayoutImageSize.width} x {LayoutImageSize.height} pixel layout image.
                        </div>
                        {!isValidLayoutImage && <Form.Control.Feedback type="invalid" className="abovehelpmsg">Please upload layout image</Form.Control.Feedback>}
                    </Form.Group>
                </Form>
            </div>
        )
    }
    const EditLayoutFooter = () => {
        return (
            <Fragment>
                <button className="w-button w-button-secondary" onClick={() => PopupClose()} >Cancel</button>
                {isDuplicate && isBuilderPage &&
                    <Dropdown>
                        <Dropdown.Toggle bsPrefix="w-button w-button-primary" id="dropdown-basic">
                            <span style={{ marginRight: "10px" }}> Save</span> <svg
                                xmlns="http://www.w3.org/2000/svg"
                                viewBox="0 0 320 512"
                                height="14"
                                width="8"
                                fill="#fff"
                            >
                                <path d="M137.4 374.6c12.5 12.5 32.8 12.5 45.3 0l128-128c9.2-9.2 11.9-22.9 6.9-34.9s-16.6-19.8-29.6-19.8L32 192c-12.9 0-24.6 7.8-29.6 19.8s-2.2 25.7 6.9 34.9l128 128z" />
                            </svg>
                        </Dropdown.Toggle>
                        <Dropdown.Menu>
                            <Dropdown.Item onClick={() => DuplicateLayout(false)}>Save</Dropdown.Item>
                            <Dropdown.Item onClick={() => DuplicateLayout(true)}>Save and Publish</Dropdown.Item>
                        </Dropdown.Menu>
                    </Dropdown>
                }
                {isDuplicate && !isBuilderPage &&
                    <button className="w-button w-button-primary" onClick={() => DuplicateLayout(false)}>Duplicate</button>
                }
                {!isDuplicate &&
                    <button className="w-button w-button-primary" onClick={() => SaveLayout()}>Save</button>
                }
            </Fragment>
        )

    }

    return createPortal(
        <VGPopUp
            id={"EditlayoutPopup"}
            show={true}
            title={isDuplicate === false ? "Edit Layout" : (isBuilderPage ? "Save As Website Layout" : "Duplicate Layout")}
            onHide={PopupClose}
            size="sm"
            body={Editbody()}
            dialogClassName="vg-w480"
            footer={EditLayoutFooter()}
            isShowFooter={true}
            backdrop={true}
            isRemoveTabModalIndex={true}
        />,
        document.getElementById("OpenDialog")
    )
}

export default AddEditlayoutPopup
